<template>
  <div >
    <a-table
      :columns="columnArr"
      :data-source="tableData"
      class="components-table"
      :customRow="clickRow"
      :loading="loading"
      :pagination="false"
      :scroll="{ y: 443 }"
    
    >
      <template slot="backEle">
        <span class="back-icon" @click="navBack">
          <a-icon type="left" />返回
        </span>
      </template>
      <template slot="clickEle" slot-scope="tdName">
        <a-tooltip>
          <template slot="title">{{tdName}}</template>
          <span class="click-ele">{{tdName}}</span>
        </a-tooltip>
      </template>
      <template slot="splitEle" slot-scope="splitText">
        <span>{{splitText | TableNumberFormat}}</span>
      </template>
      <template slot="rate" slot-scope="rateValue">
        <span class="rate-text">{{rateValue.toFixed(2) + '%'}}</span>
      </template>
      <template slot="footer" slot-scope="currentPageData">
        <template v-if="footerAvgDataObj !== null">
          <span
            style="padding: 0 16px;"
            :style="{'width': item.width+'px', 'text-align': item.dataIndex=='sort'? 'left' : 'right'}"
            v-for="(item, index) in columnArr"
            :key="index"
          >
            <span v-if="item.dataIndex=='sort'">均值</span>
            <span
              v-else-if="tableName === 'variousRate'"
            >{{footerAvgDataObj[item.dataIndex] ? (footerAvgDataObj[item.dataIndex] + '%') : ''}}</span>
            <span v-else>{{footerAvgDataObj[item.dataIndex] | TableNumberFormat}}</span>
          </span>
        </template>
        <template v-else>
          <span
            style="padding: 0 16px;"
            :style="{'width': item.width+'px', 'text-align': item.dataIndex=='sort'? 'left' : 'right'}"
            v-for="(item, index) in columnArr"
            :key="index"
          >
            <span v-if="item.dataIndex=='sort'">合计</span>
            <span v-else>{{footerData[item.dataIndex] | TableNumberFormat}}</span>
          </span>
        </template>
      </template>
    </a-table>
  </div>
</template>

<script>
export default {
  name: "indexTable",
  components: {},
  props: {
    data: {
      type: Array,
      default: [],
    },
    columns: {
      type: Object,
      required: true,
      default: () => {},
    },
    footerAvgData: {
      type: Object,
      default: () => null,
    },
    tableName: {
      type: String,
      default: "",
    },
    allNumList:{
      type:Array,
      default:()=>[]
    }
  },
  data() {
    return {
      loading: false,
      columnArr: this.columns.parent,
      currentStatisticsColumn: this.columns.parentStatistics,
      currentTable: "parentTable",
      tableData: this.data,
      // 表格底部数据
      footerAvgDataObj: null,
      // 缓存第二级数据
      childData: [],
      childFooterAvgData: {},

    };
  },
  mounted() {
    this.loading = true;
  },
  watch: {
    data(val) {
      // console.log("表格数据", val);
      this.tableData = val;
      this.columnArr = this.columns.parent;
      this.loading = false;
    },
    columns(val) {
      // console.log("表格结构", val);
    },

    footerAvgData: {
      handler(val) {
        this.footerAvgDataObj = val;
        // console.log("表格均值", val, this.footerAvgDataObj);
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    footerData() {
      let tempRes = {};
      if (Array.isArray(this.allNumList)) {
        // let tableLength = this.tableData.length;
        this.allNumList.forEach((item, index) => {
          for (let key in item) {
            try {
              if (
                typeof item[key] == "number" &&
                this.currentStatisticsColumn.includes(key)
              ) {
                tempRes[key] = (tempRes[key] || 0) + item[key];
              } else {
                // console.log(typeof tempRes[key], item[key], item, key);
                // tempRes[key] = tableLength;
              }
            } catch (error) {
              console.error(
                "问题数据：",
                item,
                error,
                this.currentStatisticsColumn
              );
              tempRes[key] = "--";
            }
          }
        });
      }
      return tempRes;
    },
  },
  methods: {
    navBack() {
      if (this.currentTable == "leafTable") {
        this.columnArr = this.columns.child;
        this.currentStatisticsColumn = this.columns.childStatistics;
        this.tableData = this.childData;
        this.footerAvgDataObj = this.childFooterAvgData;
        this.currentTable = "childTable";
      } else if (this.currentTable == "childTable") {
        this.columnArr = this.columns.parent;
        this.currentStatisticsColumn = this.columns.parentStatistics;
        this.tableData = this.data;
        this.currentTable = "parentTable";
        if (this.footerAvgData !== null) {
          // 设置表格平均律（取父级表格数据）
          this.footerAvgDataObj = this.footerAvgData;
        }
        this.$emit("countryDirection");
      }
    },
    // 将父级表格的行数据作为表格底部数据
    setFooterData(record) {
      let tempFooterAvgDataObj = {};
      for (let key in this.footerAvgData) {
        try {
          tempFooterAvgDataObj[key] = record[key] || "";
        } catch (error) {
          tempFooterAvgDataObj[key] = "--";
        }
      }
      this.footerAvgDataObj = tempFooterAvgDataObj;
    },
    // 行点击事件
    clickRow(record) {
      return {
        props: {},
        on: {
          // 事件
          click: (event) => {
            if (record.cityId) {
              this.tableData = record.districtReportList;
              this.columnArr = this.columns.child;
              this.currentStatisticsColumn = this.columns.childStatistics;
              this.currentTable = "childTable";
              if (this.footerAvgData !== null) {
                // 设置表格平均律（取父级表格数据）
                this.setFooterData(record);
              }

              // 缓存中间区县表格
              this.childData = record.districtReportList;
              this.childFooterAvgData = this.footerAvgDataObj;
              // 触发父组件--切换城市视角
              this.$emit("citySelect", record);
            } else if (record.districtId) {
              this.tableData = record.communityReportList;
              this.columnArr = this.columns.leaf;
              this.currentStatisticsColumn = this.columns.leafStatistics;
              this.currentTable = "leafTable";
              if (this.footerAvgData !== null) {
                // 设置表格平均率（取父级表格数据）
                this.setFooterData(record);
              }
            }
          },
        },
      };
    },
  },
};
</script>
<style lang="scss" scoped>
.components-table {
  width: 425px;
  height: 551px;
}
.components-table /deep/ .ant-table-row-cell-break-word {
  /* padding: 16px 8px; */
}
.click-ele {
  color: #3ba1ff !important;
  cursor: pointer !important;
}
.back-icon {
  color: #3ba1ff;
  cursor: pointer;
}
.components-table /deep/ .ant-table-footer {
  display: flex;
  padding: 16px 0;
}

.components-table /deep/ .ant-table-placeholder {
  height: 443px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.components-table /deep/ .ant-table-body {
  // height: 497px;
}

.components-table /deep/ .ant-table-tbody {
  // height: 443px;
  // overflow-y: auto;
}

.components-table /deep/ .ant-table-tbody .ant-table-row > td {
  /* text-overflow: ellipsis;
  display: block;
  width: 120px;
  overflow: hidden;
  white-space: nowrap; */
}
</style>
